import clsx from 'clsx';
import type React from 'react';

export const ToolbarButton: React.FC<{
    children: React.ReactNode;
    style?: 'default'|'primary'|'primary-toggle'|'primary-help'|'feature-accent';
    size?: 'sm'|'md'|'lg';
    isActive?: boolean;
    iconOnly?: boolean;
    rounded?: boolean;
    title?: string;
    onClick?: () => void;
    onMouseDown?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}> = ({
    style = 'default',
    size = 'md',
    iconOnly,
    rounded,
    children,
    isActive,
    title,
    onClick,
    onMouseDown,
}) => {
    return (
        <button
            className={clsx(
                'relative flex flex-row items-stretch justify-stretch shrink-0 text-sm font-medium overflow-hidden transition-all duration-200',
                size === 'sm' && iconOnly && 'w-6 h-6',
                size === 'sm' && !iconOnly && 'h-6 w-auto',
                size === 'md' && iconOnly && 'w-8 h-8',
                size === 'md' && !iconOnly && 'h-8 w-auto',
                size === 'lg' && iconOnly && 'w-9 h-9',
                size === 'lg' && !iconOnly && 'h-9 w-auto',
                rounded ? 'rounded-full' : 'rounded',
                style === 'default' && isActive && 'bg-blue-300 hover:bg-blue-400',
                style === 'default' && !isActive && 'hover:bg-gray-300',
                style === 'primary' && 'bg-primary-500 hover:bg-primary-550 text-white',
                style === 'primary-toggle' && 'border',
                style === 'primary-toggle' && isActive && 'border-primary-500 hover:bg-gray-300 text-primary-500',
                style === 'primary-toggle' && !isActive && 'border-transparent hover:bg-gray-300',
                style === 'primary-help' && 'bg-orange-500 hover:bg-red-600 text-white',
                style === 'feature-accent' && 'p-[1px] before:absolute before:-left-1/2 before:-top-1/2 before:bg-gradient-to-r before:from-primary-500 before:to-violet-800 before:w-[200%] before:aspect-square before:animate-spin before:[animation-duration:3s] before:z-0 outline outline-2 outline-transparent hover:outline-white',
            )}
            title={title}
            onClick={onClick}
            onMouseDown={onMouseDown}
        >
            <span className={clsx(
                'relative flex flex-row items-center justify-center gap-1 z-10 transition-colors duration-200 w-full',
                size === 'sm' && !iconOnly && 'pl-2 pr-2.5',
                size === 'md' && !iconOnly && 'pl-3 pr-3.5',
                size === 'lg' && !iconOnly && 'pl-3 pr-3.5',
                rounded ? 'rounded-full' : 'rounded',
                style === 'feature-accent' && !isActive && 'bg-transparent text-white',
                style === 'feature-accent' && isActive && 'bg-gray-200 hover:bg-gray-300 text-indigo-800',
            )}>{children}</span>
        </button>
    );
};
